import Animated, { useAnimatedStyle, useSharedValue, withTiming } from "react-native-reanimated";
import { FIREBASE_EVENT_NAMES, FIREBASE_EVENT_PARAMS } from "utils/Constants.js";
import React, { memo, useState } from "react";
import { ScrollView, TouchableOpacity, View } from "react-native";
import Svg, { Path } from "react-native-svg";
import { fp, hp, spV } from "utils/normalise.js";

import Accordion from "components/Accordion.js";
import FilterCategory from "./FilterCategory.js";
import VText from "components/VText";
import { analytics } from "utils/firebaseConfig.js";
import { logEvent } from "firebase/analytics";
import { useDispatch } from "react-redux";

const FilterRow = ({ filter = {}, appliedData = [] }) => {
    const [isOpen, setIsOpen] = useState(false);

    const dispatch = useDispatch();

    const rotate = useSharedValue(180);

    const animatedStyles = useAnimatedStyle(() => ({
        transform: [{ rotateZ: `${rotate.value}deg` }],
    }));

    return (
        <View
            style={{
                flex: 1,
            }}
        >
            <>
                <TouchableOpacity
                    style={{
                        marginTop: spV(8),
                        paddingBottom: spV(8),
                        borderBottomWidth: 2,
                        borderColor: "rgba(33, 36, 39, 0.3)",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                    onPress={() => {
                        setIsOpen((prev) => {
                            if (prev) {
                                rotate.value = withTiming(180);
                                return false;
                            } else {
                                logEvent(analytics, FIREBASE_EVENT_NAMES.FILTER_CLICKED, {
                                    [FIREBASE_EVENT_PARAMS.FILTER_NAME]: filter?.title,
                                });
                                rotate.value = withTiming(0);
                                return true;
                            }
                        });
                    }}
                    activeOpacity={0.8}
                >
                    <View
                        style={{
                            width: "85%",
                        }}
                    >
                        <VText
                            text={filter?.id === 6 ? "Size" : filter?.id === 2 ? "Brands" : filter?.title}
                            style={{
                                fontSize: fp(15),
                                fontWeight: "550",
                                lineHeight: fp(24),
                                marginBottom: 2,
                            }}
                        />
                        <View
                            style={{
                                flexDirection: "row",
                                flexWrap: "wrap",
                                marginTop: 4,
                                flex: 1,
                            }}
                        >
                            <VText
                                style={{
                                    fontSize: fp(13),
                                    fontWeight: "350",
                                    lineHeight: fp(20),
                                    color: "rgba(33, 36, 39, 0.6)",
                                }}
                                text={
                                    Array.isArray(appliedData) &&
                                    appliedData?.map(
                                        (item, idx) => `${item?.title}${idx == appliedData?.length - 1 ? "" : ","} `
                                    )
                                }
                            />
                        </View>
                        {!(appliedData?.length > 0) && (
                            <VText
                                text={"All"}
                                style={{
                                    fontSize: fp(13),
                                    fontWeight: "350",
                                    lineHeight: fp(20),
                                    color: "rgba(33, 36, 39, 0.6)",
                                }}
                            />
                        )}
                    </View>
                    <Animated.View style={animatedStyles}>
                        <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <Path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M20 15.7006L18.7006 17L12 10.2994L5.29937 17L4 15.7006L12 7.70064L20 15.7006Z"
                                fill="#212427"
                            />
                        </Svg>
                    </Animated.View>
                </TouchableOpacity>
                <Accordion viewKey="qwerty" isExpanded={isOpen} enterFrom="top">
                    <ScrollView
                        style={{
                            maxHeight: hp(500),
                            paddingTop: [1, 6].includes(filter?.id) ? 0 : spV(16),
                        }}
                    >
                        <FilterCategory hide={() => {}} currentFilters={filter} />
                    </ScrollView>
                </Accordion>
            </>
        </View>
    );
};

export default memo(FilterRow);
